
const SERVER_URL = '';

export { SERVER_URL as serverUrl };
